export class Section {
  sectionTitle!: string
  sectionBody!: string
}
